import { render, staticRenderFns } from "./WorkActionsRelatedMaterial.vue?vue&type=template&id=f1c7ffa6&scoped=true&"
import script from "./WorkActionsRelatedMaterial.vue?vue&type=script&lang=js&"
export * from "./WorkActionsRelatedMaterial.vue?vue&type=script&lang=js&"
import style0 from "./WorkActionsRelatedMaterial.vue?vue&type=style&index=0&id=f1c7ffa6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1c7ffa6",
  null
  
)

export default component.exports